export const step3 = {
  companyTypeList: [
    {
      title: '주식회사',
      descriptions: {
        definition: `주식의 인수가액에 대한 출자의무만을 부담하며, 회사의 지분 전부가 1인에 귀속된 회사`,
        member: `사내이사 1인, 지분없는 이사 혹은 감사 1인 (2인)`,
        pros: `지분을 증권화하여 자유롭게 양도`,
        cons: `이해관계인이 많아 규제가 많음 (주주총회, 공시의무)`,
      },
    },
    {
      title: '유한회사',
      descriptions: {
        definition: `사원의 출자금액을 한도로 책임을 지는 회사`,
        member: `이사 1인`,
        pros: `주식회사에 비해 재무 상태의 공개 의무가 없음`,
        cons: `지분을 증권화할 수 없음 (상장 불가)`,
      },
    },
    {
      title: '특수목적법인(SPC)',
      descriptions: {
        definition: `특수한 목적을 수행하기 위해 일시적으로 만들어지는 임시회사`,
        member: `사내이사 1인, 지분없는 이사 혹은 감사 1인 (2인)`,
        pros: `기존 사업체의 자산 및 부채에 영향을 주지 않게 되며, 투자자의 입장에서도 수익의 관리를 독립하여 감독`,
        cons: `페이퍼컴퍼니로 오해받을 가능성이 있음`,
      },
    },
    {
      title: '(예비)사회적기업',
      descriptions: {
        definition: `사회적 가치를 우위에 두고, 공동의 이익을 목적으로 하는 회사`,
        member: `사내이사 1인, 지분없는 이사 혹은 감사 1인(2인)`,
        pros: `사회적 문제 해결과 경제적 가치 창출을 동시에 추구`,
        cons: `복잡한 인증 절차`,
      },
    },
    {
      title: '기타법인',
      descriptions: {
        definition: ``,
        member: ``,
        pros: ``,
        cons: ``,
      },
    },
  ],

  get isNextBtnActive() {
    return this.userInput.companyType !== '';
  },
};
